<app-admin-sidebar></app-admin-sidebar> <app-adminheader></app-adminheader>
<div class="dash" *ngIf="pre_order_list" [class.select]="loading" [class.selectable]="!loading">
  <div class="trip-acoordion">
    <div class="dash-trucks-top1">
      <!-- Add your links here, e.g. -->
      <!-- <a [ngClass]="{ active: tripType == 'all' }">All</a>
      <a [ngClass]="{ active: tripType == 'allocated' }">Allocated</a>
      <a [ngClass]="{ active: tripType == 'available' }">Available</a> -->
    </div>
  </div>

  <div class="trucks mt-5">
    <div [class.spinner]="loading"></div>

    <!-- <div class="row to_container" *ngIf="!preorderData?.length && !loading">
      <h4 class="error_msg">No Records Found.</h4>
    </div> -->

    <div class="row m-0" style="gap: 5px">
      <div class="cards" *ngFor="let item of preorderData">
        <mat-card class="truck-list">
          <div class="header-row">
            <span class="header_cls">Corporate Pre-Order</span>
            <button class="order-button">{{ item.workorder_id }}</button>
          </div>

          <div class="row m-0">
            <div class="col-md-5 px-1 truck_details_loc">
              <!-- <img src="../../../assets/img/location-payment.svg" alt="" /> -->
              <img [src]="item.trip_stops_id
                        ? '../../../assets/img/location-payment-stop.svg' 
                        : '../../../assets/img/location-payment.svg'"
                [matTooltip]="item.stops?.length > 0 ? ('Stops: ' + item.stops.length) : ''"
                [matTooltipDisabled]="!item.trip_stops_id" matTooltipPosition="right" alt="" />
              <div class="places">
                <p>{{ item.pickup_details.from_city_name }}</p>
                <p>{{ item.dropoff_details.to_city_name }}</p>
              </div>
            </div>
          </div>

          <div class="card-details">
            <div class="row m-0">
              <div class="col-sm-6 px-1 d-flex align-items-center">
                <div class="image">
                  <img src="../../../assets/img/Calendar.svg" />
                </div>
                <div class="date">
                  <span class="mt-2 ml-2 text-center fst-italic fw-light">{{
                    item.pickup_date | date : "dd-MM-yyyy"
                    }}</span>
                </div>
              </div>
              <div class="col-sm-6 px-1 d-flex align-items-center justify-content-center">
                <div class="image">
                  <img src="../../../assets/img/box.svg" />
                </div>
                <div class="date">
                  <span class="mt-2 ml-2 text-center fst-italic fw-light">{{
                    item.material_type
                    }}</span>
                </div>
              </div>
            </div>

            <div class="row m-0">
              <div class="col-sm-6 px-1 d-flex align-items-center">
                <div class="image">
                  <img src="../../../assets/img/truck (1).svg" />
                </div>
                <div class="date">
                  <span class="mt-2 ml-2 text-center fst-italic fw-light">{{
                    item.truckcategoryInfo[0]?.truck_category_name
                    }}</span>
                </div>
              </div>
              <div class="col-sm-6 px-1 d-flex align-items-center justify-content-center">
                <div class="image" style="width: 1px">
                  <img src="../../../assets/img/pre_order.png" />
                </div>
                <div class="date">
                  <span class="mt-2 ml-3 text-center fst-italic fw-light" style="margin-right: -9px">{{ item.total_tons
                    }} MT</span>
                </div>
              </div>
            </div>

            <div class="row m-0">
              <div class="col-sm-12 d-flex align-items-center">
                <div class="image">
                  <img src="../../../assets/img/person.png" />
                </div>
                <div class="date">
                  <span class="mt-2 ml-3 text-center fst-italic fw-light">{{
                    item.userInfo.username
                    }}</span>
                </div>
              </div>
            </div>

            <div class="row m-0">
              <div class="col-sm-6 px-1 d-flex align-items-center">
                <div class="image">
                  <img src="../../../assets/img/mobile_friendly.png" />
                </div>
                <div class="date">
                  <span class="mt-2 ml-3 text-center fst-italic fw-light">{{
                    item.userInfo.mobile
                    }}</span>
                </div>
              </div>
              <div class="col-sm-6 px-1 d-flex justify-content-end align-items-end">
                <div class="credit_trip">
                  <button class="reject-button" (click)="viewWo(item)">
                    View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <div *ngIf="paginationTrips">
    <div *ngIf="last_page && last_page > 1" class="pagination">
      <button class="btn" [disabled]="fetch_page == 1 || loading" (click)="pagination('-1')">
        <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button class="btn" [disabled]="fetch_page == 1 || loading" (click)="pagination('first')">
        <img src="../../../assets/img/pagination-left.svg" alt="" class="btn--icon" />
      </button>
      <div class="pages">
        <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
      </div>
      <button class="btn" [disabled]="last_page == fetch_page || loading" (click)="pagination('last')">
        <img src="../../../assets/img/pagination-right.svg" alt="" class="btn--icon" />
      </button>
      <button class="btn" [disabled]="last_page == fetch_page || loading" (click)="pagination('1')">
        <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>
</div>

<!-- view pre order wo -->
<div class="dash" *ngIf="pre_order_view">
  <div [class.spinner]="loading"></div>

  <div class="row mt-5 d-flex align-items-center justify-content-between">
    <div class="col-sm-3 d-flex justify-content-between Id">
      <span>PN ID #{{ woData.pn_id }}</span>
      <img (click)="editWo(woData)" src="../../../assets/img/edit.svg" alt="" [ngClass]="{
          disabled: socketTimer?.remainingTime === 'Expired'
        }" [attr.disabled]="socketTimer?.remainingTime === 'Expired' ? true : null" />
    </div>

    <div class="col-sm-2 d-flex align-items-center justify-content-between image">
      <span class="Time">Time Left : </span>
      <span class="minutes" [ngStyle]="{
          color: socketTimer?.remainingTime === 'Expired' ? 'red' : '#25c35B'
        }" style="margin-right: 30px">{{ socketTimer?.remainingTime }}</span>
    </div>

    <mat-divider></mat-divider>

    <div class="details mt-2">
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-sm-4">WO ID: {{ woData?.workorder_id }}</div>
        <div class="col-sm-4">
          From:
          {{ woData?.pickup_details?.from_city_name }}
        </div>
        <div class="col-sm-4">
          WO Qty:
          {{ woData?.total_tons | number : "1.2-3" }} MT
        </div>
      </div>
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-sm-4">
          WO Date:
          {{ woData?.pickup_date | date : "dd-MM-yyyy" }}
        </div>
        <div class="col-sm-4">
          Stops: {{ getStopNames(woData.stops) }}
        </div>
        <div class="col-sm-4">
          Allotted Qty:
          {{
          allottedQty !== 0
          ? (allottedQty > woData.total_tons
          ? (woData.total_tons | number : '1.2-3')
          : (allottedQty | number : '1.2-3'))
          : ((woData.total_tons - woData.remaining_tons) > woData.total_tons
          ? (woData.total_tons | number : '1.2-3')
          : ((woData.total_tons - woData.remaining_tons) | number : '1.2-3'))
          }}
          MT
        </div>
      </div>
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-sm-4">
          Customer Name: {{ woData?.userInfo?.username }}
        </div>
        <div class="col-sm-4">
          To: {{ woData?.dropoff_details?.to_city_name }}
        </div>
        <div class="col-sm-4">
          Bids Received:
          {{ bidRankingData.length }}
        </div>

      </div>
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-sm-4">
          Customer Mobile:
          {{ woData?.userInfo?.mobile }}
        </div>
        <div class="col-sm-4">Material: {{ woData?.material_type }}</div>
        <div class="col-sm-4">
          Trips Created:
          {{
          tripBookedCount != null && tripBookedCount !== undefined && tripBookedCount !== 0
          ? tripBookedCount
          : (woData?.bidConfirmTripsInfo?.length || 0)

          }}
        </div>
      </div>
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-sm-4">
          Truck Category:
          {{ woData?.truckcategoryInfo[0]?.truck_category_name }}
        </div>
        <div class="col-sm-4">
          WO Price Per Ton:
          {{ woData?.price_per_ton | number : "1.2-2" }}
        </div>
        <div class="col-sm-4">
          Total L Qty:
          {{ totalLoadingPoints || 0 | number : "1.2-2" }} MT
        </div>
      </div>
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-sm-4">
          Bid Status:
          <span [ngClass]="{
              'expired-rejected':
                woData?.workorder_time_status === 'expired' ||
                woData?.workorder_time_status === 'rejected',
              'normal-status':
                woData?.workorder_time_status !== 'expired' &&
                woData?.workorder_time_status !== 'rejected'
            }" [ngStyle]="{
              color:
                socketTimer?.remainingTime === 'Expired' ? 'red' : '#25c35B'
            }">
            <!-- Conditionally show 'Expired' or the status based on socketTimer remaining time -->
            {{
            socketTimer?.remainingTime === "Expired" ? "Expired" : "Active"
            }}
          </span>
          <!-- <span class="expired">Expired</span> -->
        </div>

        <div class="col-sm-4">
          S9 CutOff Price:
          {{ calculateS9CutOffPrice(woData) | number: "1.2-2" }}
          / MT ({{ getEffectiveMargin(woData) }}%)
        </div>

        <div class="col-sm-4">
          Total U Qty:
          {{ totalUnloadingPoints || 0 | number: "1.2-2" }} MT
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="table-wrapper" *ngIf="selectedData?.length > 0">
      <!-- Loader inside the table -->
      <div *ngIf="socketLoading" class="table-loader">
        <div class="dot-pulse-loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <div class="table-container">
        <table width="100%">
          <thead>
            <tr>
              <th>TRUCK OWNER ID</th>
              <th>TRUCK OWNER MOBILE</th>
              <th>DRIVER ID</th>
              <th>DRIVER MOBILE</th>
              <th>DRIVER ORDER ID</th>
              <th>TRUCK TYPE</th>
              <th>BILLING QTY</th>
              <!-- <th>Qty (as per {{ item.workorderInfo[0]?.pay_as_load_quantity === 'loaded_quantity' ? 'Loading' : 'Unloading' }})</th> -->
              <th>PR MT</th>
              <th>TR PRICE</th>
              <th>PN STATUS</th>
              <th>TRIP ID</th>
              <th>Assigned From</th>
              <!-- <th>PN ID</th> -->
              <!-- <th>TR BID JOIN DATE</th> -->
              <!-- <th>WO/ QID</th> -->
            </tr>
          </thead>
          <tbody>
            <!-- Show "No Records Found" if no data -->
            <tr *ngIf="!socketLoading && selectedData?.length === 0">
              <td colspan="13" class="no-records">No Records Found.</td>
            </tr>
            <!-- Display Data -->
            <tr *ngFor="let item of selectedData">
              <td>{{ item.truckownerInfo[0]?.truckowner_id }}</td>
              <td>{{ item.truckownerInfo[0]?.mobile }}</td>
              <td>{{ item.driverInfo[0]?.driver_id }}</td>
              <td>{{ item.driverInfo[0]?.mobile }}</td>
              <td>{{ item.driverRouteInfo[0]?.driver_route_unique_id }}</td>
              <td>
                {{ item.truckTypeInfo[0]?.truck_weight }}
                <i *ngIf="item.tripInfo[0]?.trip_id && item.truckTypeInfo[0]?.truck_weight !== (item.tripInfo[0]?.workorder_qty + ' MT')"
                  class="pi pi-info-circle ml-2 text-warning"
                  pTooltip="Alloted Qty: {{ item.tripInfo[0]?.workorder_qty }} MT" tooltipPosition="top"
                  style="vertical-align: middle;">
                </i>
              </td>
              <td>
                {{
                (
                item.workorderInfo[0]?.pay_as_load_quantity === 'loaded_quantity'
                ? item.tripInfo[0]?.workOrderOtherDetails?.loading_point
                : item.tripInfo[0]?.workOrderOtherDetails?.unloading_point
                ) || 0
                | number : '1.2-2' }}
              </td>
              <td>{{ item.price | number : "1.2-2" }}</td>
              <td>{{ getTotalPrice(item) | number : "1.2-2" }}</td>
              <td>{{ item.trip_status.toUpperCase() }}</td>
              <td>{{ item.tripInfo[0]?.trip_id || "-" }}</td>
              <td>
                {{
                item?.userInfo?.[0]?.user_type === 'truckowner' ? 'PreOrders' :
                item?.userInfo?.[0]?.user_type === 'admin' ? 'Admin' :
                item?.userInfo?.[0]?.user_type === 'driver' ? 'Driver' : 'NA'
                }}
              </td>
              <!-- <td>{{ item.workorderInfo[0]?.pn_id }}</td> -->
              <!-- <td>{{ item.createdAt | date : "dd-MM-yyyy" }}</td> -->
              <!-- <td>{{ item.workorderInfo[0]?.workorder_id }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="table-wrapper" *ngIf="bidRankingData && bidRankingData.length > 0">
      <!-- Loader inside the table -->
      <div *ngIf="socketLoading" class="table-loader">
        <div class="dot-pulse-loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <div class="table-container">
        <table width="100%">
          <thead>
            <tr>
              <th>PN ID</th>
              <th>WO/ QID</th>
              <th>TR BIDDING DATE</th>
              <th>TRUCK OWNER ID</th>
              <th>TRUCK OWNER MOBILE</th>
              <th>PR MT</th>
              <th>RANKING</th>
              <th>TIMER</th>
            </tr>
          </thead>
          <tbody>
            <!-- Show "No Records Found" if no data -->
            <tr *ngIf="!socketLoading && bidRankingData?.length === 0">
              <td colspan="8" class="no-records">No Records Found.</td>
            </tr>

            <!-- Display Data -->
            <tr *ngFor="let item of bidRankingData; let i = index">
              <td>{{ item.workOrderDetails?.pn_id || '-' }}</td>
              <td>{{ item.workOrderDetails?.workorder_id || '-' }}</td>
              <td>{{ item.createdAt | date : 'dd-MM-yyyy' }}</td>
              <td>{{ item.truckOwnerDetails[0]?.truckowner_id || '-' }}</td>
              <td>{{ item.truckOwnerDetails[0]?.mobile || '-' }}</td>
              <td>{{ item.bid_rate | number : '1.2-2' }}</td>
              <!-- <td>{{ item.bid_ranking || '-' }}</td> -->
              <td>L{{ i + 1 }}</td>
              <td>{{ getRemainingTime(item?.ranking_expiry_time, woData?.corporate_ranking_timer) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>